import { render, staticRenderFns } from "./quick-message.vue?vue&type=template&id=d7bce20a"
import script from "./quick-message.vue?vue&type=script&lang=js"
export * from "./quick-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7bce20a')) {
      api.createRecord('d7bce20a', component.options)
    } else {
      api.reload('d7bce20a', component.options)
    }
    module.hot.accept("./quick-message.vue?vue&type=template&id=d7bce20a", function () {
      api.rerender('d7bce20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bulk-message/quick-message.vue"
export default component.exports